import { render, staticRenderFns } from "./TableForPage.vue?vue&type=template&id=10a133a2&"
import script from "./TableForPage.vue?vue&type=script&lang=js&"
export * from "./TableForPage.vue?vue&type=script&lang=js&"
import style0 from "./TableForPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports